module.exports = __webpack_public_path__ + "static-appopensalud/img/RGB_Neom_positivo.8dfd1fe.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/RGB_Neom_positivo.svg
// module id = 1016
// module chunks = 116